import { isValueExist } from '@/utils/utils';
import { ErrorSourceRow } from './ErrorSourceRow';
import { Wrapper } from './styles';

export const ErrorSourceList = {
    name: 'ErrorSourceList',
    props: {
        errorCode: {
            type: String,
        },
        sourceList: {
            type: Array,
        },
        doNotShow: {
            type: Boolean,
            default: true,
        },
        lastErrorSource: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    render() {
        if (this.doNotShow) {
            return null;
        }

        return (
            <Wrapper class="error-source-table">
                {this.sourceList.map((eachSource, idx, list) => {
                    const { properties = {} } = eachSource;

                    const { dataSource, connectorType } = properties;

                    // if (!isValueExist(dataSource)) return null;

                    let {
                        name,
                        id,
                        disableAt = '',
                        logo,
                        adAccountId, // from account, not from response > data > properties > dataSource

                        // GA: different data structure
                        properties: GAProperties = [],
                    } = dataSource || {};

                    // GA: different data structure
                    if (isValueExist(GAProperties)) {
                        ({ name, id } = GAProperties[0]);
                    }

                    return (
                        <ErrorSourceRow
                            rowSize={list.length}
                            logoUrl={logo}
                            connectorType={connectorType}
                            showConnectorType={idx === 0}
                            sourceId={id ?? adAccountId}
                            name={name}
                            disableAt={disableAt}
                            lastErrorSource={this.lastErrorSource}
                        />
                    );
                })}
            </Wrapper>
        );
    },
};
